<template>
    <div>
        <div class="field">
            <InputGroup>
                <InputGroupAddon>Email</InputGroupAddon>
                <InputText :readonly="readonlyEmail"
                           v-model="memberDetails.email"
                           placeholder="Your email address" dusk="email"
                           :invalid="v$.memberDetails.email.$invalid" />
            </InputGroup>
        </div>
        <div class="field">
            <InputGroup>
                <InputGroupAddon>Name</InputGroupAddon>
                <InputText :readonly="readonlyName"
                           v-model="memberDetails.name"
                           placeholder="Your name"
                           :invalid="v$.memberDetails.name.$invalid" />
            </InputGroup>
        </div>
        <div class="field" v-if="isTieredOffer">
            <InputGroup class="mt-3">
                <InputGroupAddon>Select number of subscriptions</InputGroupAddon>
                <InputNumber v-model="subscriptionDetails.quantity" class="w-3"
                             showButtons
                             :min="2" :max="99999" :step="1"
                             @value-change="tierQuantityChangedAction"
                >
                </InputNumber>
            </InputGroup>

            <InputGroup class="mt-3">
                <InputGroupAddon>Price</InputGroupAddon>
                <InputText v-model="priceDescription" readonly />
                <InputGroupAddon>{{ subscriptionDetails.planCurrency }}</InputGroupAddon>
            </InputGroup>
        </div>
        <div class="field" v-if="!isTieredOffer">
            <InputGroup>
                <InputGroupAddon>Price</InputGroupAddon>
                <InputText v-model="subscriptionDetails.planName" readonly />
                <InputGroupAddon>{{ subscriptionDetails.planCurrency }}</InputGroupAddon>
            </InputGroup>
        </div>
        <div class="field" v-if="subscriptionDetails.giftSubscription">
            <Textarea
                v-model="subscriptionDetails.customMessage"
                placeholder="Optional Message"
                rows="3"
                max-rows="6"
            ></Textarea>
        </div>

        <div class="field text-center text-lg font-semibold"
             v-if="subscriptionDetails.text&&subscriptionDetails.text.beforePrice"
        >
            {{subscriptionDetails.text.beforePrice}}
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import {useVuelidate} from '@vuelidate/core'
import {required, email} from '@vuelidate/validators'

export default {
    setup() {
        return {v$: useVuelidate()}
    },
    props: {
        modelValue: {}
    },
    emits: ['tierQuantityChanged'],
    components: {
    },
    data () {
        return {
            subscriptionDetails: {
            },
            memberDetails: {
                name: null,
                email: null
            },
            readonlyName: false,
            readonlyEmail: false,
            priceDescription2: null,
        }
    },
    computed: {
        isTieredOffer() {
            return this.subscriptionDetails.type === 'offer_with_tiers'
        },
        priceDescription() {
            const quantity = this.subscriptionDetails.quantity
            const itemPrice = this.getOneItemPricePrice(quantity)
            const itemPriceValue = itemPrice / 100
            const price = quantity * itemPriceValue

            this.updatePlanPrice()

            return `${quantity} x ${itemPriceValue} = ${price}/Year`
        }
    },
    created () {
        this.subscriptionDetails = this.modelValue
        this.memberDetails = this.modelValue.memberDetails

        if (!this.subscriptionDetails) {
            this.alertError('Wrong subscription URL');
        } else {
            if (this.subscriptionDetails.memberDetails.name) {
                this.readonlyName = true
            }
            if (this.subscriptionDetails.memberDetails.email) {
                this.readonlyEmail = true
            }
        }
        this.updatePlanPrice()
    },
    methods: {
        ...mapActions({
            'alertSuccess': 'alert/success',
            'alertError': 'alert/error',
        }),
        getOneItemPricePrice(quantity) {
            const tiers = this.subscriptionDetails.planTiers || []
            let itemPrice = 0
            let stop = false

            tiers.slice().reverse().forEach((tier, index) => {
                if (tier.up_to && tier.up_to < quantity) {
                    stop = true;
                }
                if (!stop) {
                    itemPrice = tier.unit_amount
                }
            });

            return itemPrice
        },
        updatePlanPrice() {
            const quantity = this.subscriptionDetails.quantity
            if (quantity) {
                const itemPrice = this.getOneItemPricePrice(quantity)

                // set subscription price for future processing
                this.subscriptionDetails.planPrice = quantity * itemPrice
            }
        },
        tierQuantityChangedAction() {
            this.$emit('tierQuantityChanged', this.subscriptionDetails.quantity)
        }
    },
    validations: {
        memberDetails: {
            email: {
                required,
                email
            },
            name: {
            },
        }
    }
}
</script>

